<template>
    <footer class="bg-gray-900 text-white py-10 font-serif">
        <div class="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
      
         
          <div>
            <h2 class="text-2xl font-serif font-bold mb-4">Hôtel Booking</h2>
            <p class="text-sm text-gray-300">
             Notre mission est de trouver les hotels qui vous correspondent le plus
            </p>
          </div>
      
      
          <div>
            <h3 class="text-lg font-semibold mb-3">Liens utiles</h3>
            <ul class="space-y-2 text-sm text-gray-400">
              <li><a href="#" class="hover:text-white transition">Accueil</a></li>
              <li><a href="#" class="hover:text-white transition">Chambres</a></li>
              <li><a href="#" class="hover:text-white transition">Reservations</a></li>
              <li><a href="#" class="hover:text-white transition">Contact</a></li>
            </ul>
          </div>
      
          <div>
            <h3 class="text-lg font-semibold mb-3">Contact</h3>
            <p class="text-sm text-gray-400">📍 Lomé, Togo</p>
            <p class="text-sm text-gray-400">📞 +228 00000000</p>
            <p class="text-sm text-gray-400">📧 contact@hotelbooking.tg</p>
          </div>
      
      
          <div>
            <h3 class="text-lg font-semibold mb-3">Suivez-nous</h3>
            <div class="flex space-x-4 text-gray-400 text-xl">
              <a href="#" class="hover:text-white transition"><img src="/image/face.png" alt="Logo HotelBook" class="h-8 w-8 text-green-600 mr-2"></a>
              <a href="#" class="hover:text-white transition"><img src="/image/tik.png" alt="Logo HotelBook" class="h-8 w-8 text-green-600 mr-2"></a>
              <a href="#" class="hover:text-white transition"><img src="/image/insta.png" alt="Logo HotelBook" class="h-8 w-8 text-green-600 mr-2"></a>
            </div>
          </div>
      
        </div>
      
        <div class="mt-8 text-center text-sm text-gray-500 border-t border-gray-800 pt-4">
          &copy; 2025 Hôtel Booking. Tous droits réservés.
        </div>
      </footer>
      </template>
    
    <script>
    export default {
       name : "FooterVue"
    };
    </script>